import {useTranslation} from "react-i18next";

export function useComponentLocale() {
    const {t} = useTranslation()
    
    return function ({component, section}) {
        const localeTopBar = section ? t(`${component}.${section}`) : t(`${component}`)
        
        return localeTopBar
    }
}